import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as returnsSearchOptions from '../../../../../constants/returnSearchOptions';
import { getSelectedReturnsSearchAction } from '../../../../../selectors/tools';
import { trackReturnSearchSetAction } from '../../../../../analytics/searchEventAnalytics';
import {
  selectReturn,
  setSearchReturnsAction,
} from '../../../../../actions/tools/CommonInterface/Returns/ReturnActions';
import { SearchPageSelect } from '../../../../../components/tools/SearchPage/Search.styles';

const SearchOptions = () => {
  const dispatch = useDispatch();

  const selectedSearchAction = useSelector(getSelectedReturnsSearchAction);

  const handleActionSelection = (event) => {
    // clear old data
    dispatch(selectReturn({}));

    const selectedAction = event.target.value;

    trackReturnSearchSetAction({ action: selectedAction });

    return dispatch(setSearchReturnsAction(selectedAction));
  };

  return (
    <SearchPageSelect onChange={handleActionSelection} value={selectedSearchAction}>
      <option
        key={returnsSearchOptions.SEARCH_RETURNS_BY_ORDER_NUMBER}
        value={returnsSearchOptions.SEARCH_RETURNS_BY_ORDER_NUMBER}
      >
        Get returns by order number
      </option>
    </SearchPageSelect>
  );
};

export default SearchOptions;
